import React from "react";
import { useTranslation } from "react-i18next";
import { Checkboxes } from "../../../FlowConfigurationInputs";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function VLookUp ({ action, variables, setOpenVariable, showAlert }) {
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.EXCEL.VLOOKUP.";
    const options = {
        fileInput: {
            checkExtension: (ext) => {
                if (ext.toLocaleLowerCase() !== "xls" && ext.toLocaleLowerCase() !== "xlsx") {
                    showAlert(t(label + "UPLOAD_EXCEL_ONLY"));
                    return false;
                }
                return true;
            },
            fileType:
                "application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        checkboxes: { label: label + "APPROXIMATE-VALUE" },
    };

    return (
        <>
            <div className="form-element">
                <div className="form-element">
                    {t(label + 'EXCEL-SOURCE')}
                    <VariablePicker action={action} inputName="excelSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="data table" isRequired />
                    <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                </div>
            </div>
            <div className="form-element">
                {t(label + "SEARCHABLE-COLUMN")}
                <TextInput
                    action={action}
                    inputName="searchableColumn"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                />
            </div>
            <div className="form-element">
                {t(label + "SEARCH-TEXT")}
                <TextInput
                    action={action}
                    inputName="qText"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                />
            </div>
            <div className="form-element">
                {t(label + "FILE-PATH")}
                <VariablePicker
                    action={action}
                    inputName="vlookupSource"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                />
            </div>
            <div className="form-element">
                {t(label + "FIND-COLUMN")}
                <TextInput
                    action={action}
                    inputName="findColumn"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                />
            </div>
            <div className="form-element">
                <Checkboxes
                    action={action}
                    inputName="appMatch"
                    options={options.checkboxes}
                />
            </div>
            <div className="form-element">
                {t(label + "ASSIGN-SOURCE")}
                <VariablePicker
                    action={action}
                    inputName="set"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    filter={"string"}
                    isRequired
                />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div>
        </>
    );
}
export default VLookUp;